import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {fetchAppIfNeeded} from '../actions/apps';
import {closeAppMarketModal} from '../services/wrapped-app-market-sdk';
import {openBusinessApp} from '../services/app-flow';
import {execBI} from '../services/bi-events-manager';

const closeModal = () => {
  return closeAppMarketModal('provisionSuccessMessage');
};

const handleClose = (app, closing_method) => {
  return (ev) => {
    ev.preventDefault();
    return execBI('UNIFICATION_PROVISION_CLOSE', {app, closing_method}).then(closeModal);
  };
};

const handleOpen = (app) => {
  return (ev) => {
    ev.preventDefault();
    openBusinessApp(app, 0);
    execBI('UNIFICATION_PROVISION_GO_TO_CLICK', {app, origin: 'unification_modal'}).then(closeModal);
  };
};


class ProvisionModal extends React.Component {

  static fetchData(dispatch, params) {
    const appSlug = params.appSlug;
    return dispatch(fetchAppIfNeeded(appSlug));
  }

  componentDidMount() {
    execBI('UNIFICATION_PROVISION_OPEN', {app: this.props.data});
  }

  render() {
    const app = this.props.data;

    return (
      <div className="permission-modal">
        {this.props.isFetching ?
          <div>Loading</div> :
          <div className="provision-success-modal">
            <div className="provision-success-message">
              <button type="button" className="close-button" onClick={handleClose(app, 'x')}><span>&times;</span></button>
              <div className="header">
                <h2><FormattedMessage id="editorProvisionModal.title"/></h2>
                <p className="description"><FormattedMessage id="editorProvisionModal.description" values={{name: app.name}}/></p>
                <div className="provision-img"></div>
              </div>

              <div className="body">
                <div>
                  <div className="instructions">
                    <p><FormattedMessage id="editorProvisionModal.instructions"/></p>
                  </div>
                  <div className="open">
                    <a className="browse-later" onClick={handleClose(app, 'later')} href="#">
                      <FormattedMessage id="editorProvisionModal.browseLater"/>
                    </a>
                    <a className="goto" onClick={handleOpen(app)} href="#"><FormattedMessage id="editorProvisionModal.open"/></a>
                  </div>
                </div>
              </div>
            </div>
          </div> }
      </div>
    );
  }
}

ProvisionModal.propTypes = {
  data: PropTypes.object,
  isFetching: PropTypes.bool.isRequired,
  dispatch: PropTypes.func
};


function mapStateToProps(state, props) {
  const appSlug = props.params.appSlug;
  const {data, isFetching} = state.apps.list[appSlug] || {data: {}, isFetching: true};
  return {data, isFetching};
}

export default connect(mapStateToProps)(ProvisionModal);

// remove this file when merge AppPageInsideMarket experiment



// WEBPACK FOOTER //
// ./containers/Provision-modal.js